import { LoginForm } from '@/components/features/auth/LoginForm';
import AuthView from '@/layout/AuthView';

export default function LoginPage() {
  return (
    <AuthView>
      <div
        className={
          'border-border-primary bg-background z-10 flex h-[85dvh] max-h-[calc(100dvh-var(--spacing)*8)] min-h-100 w-full flex-col items-center overflow-auto rounded-2xl rounded-b-none px-4 pt-6 pb-11 shadow-lg md:h-fit md:w-[clamp(20rem,50dvw,26rem)] md:rounded-b-2xl md:border-4 md:p-4'
        }
      >
        <LoginForm />
      </div>
    </AuthView>
  );
}
